import EditDealerModal from "./EditDealerModal";

export default EditDealerModal;